export const WALLET_TRANSACTION_ACTION = Object.freeze({
  ORDER_ITEM_WALLET_DEDUCTION: "ORDER_ITEM_WALLET_DEDUCTION",
  MECHANIC_TOPUP: "MECHANIC_TOPUP",
});

export const WALLET_TRANSACTION_ACTION_MAP = new Map([
  [WALLET_TRANSACTION_ACTION.ORDER_ITEM_WALLET_DEDUCTION, "تم خصم بونص إسبوعي"],
  [WALLET_TRANSACTION_ACTION.MECHANIC_TOPUP, "تم إيداع بونص إسبوعي"],
]);
